import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import { gsap } from "../gsap/gsap.min.js";
import { SplitText } from "../gsap/all.js";
import "../../scss/application.scss";

const reactAppRoot = document.getElementById('react-root-epoca');

if (reactAppRoot) {
    ReactDOM.createRoot(reactAppRoot).render(
        <App />
        //<React.StrictMode>
        //    <App />
        //</React.StrictMode>,
    )
}
 